<template>
  <div
    class="col-12 lg-col-4 md-col-12 sm-col-4 xs-col-12 flex flex-column justify-between p2"
  >
    <!-- RemainingSessions -->
    <div
      v-if="!billet.order_contremarque"
      class="col-12 flex justify-center center"
    >
      <h3
        v-if="
          !billet.unlimited_usage &&
          billet.remainingQuantity &&
          billet.hasRemainingReservations
        "
        class="cond bold h5n my0"
      >
        {{ billet.remainingQuantity }}
        <span v-if="billet.remainingQuantity === 1"> session restante</span>
        <span v-else> sessions restantes</span>
      </h3>
    </div>

    <!-- QRCODE -->
    <div class="inline-block qrcode no-box flex flex-column items-center">
      <div
        v-if="
          billet.qrcodeSvg &&
          !billet.order_contremarque &&
          !billet.order_sans_support
        "
        style="width: 100px"
        v-html="billet.qrcodeSvg"
      ></div>
      <div v-else-if="billet.order_contremarque" class="pointer grey-bg p1">
        Pour activer votre e-billet, veuillez vous rendre à l’accueil du centre.
      </div>
      <span v-if="!billet.order_sans_support" class="h5n my1">{{
        billet.qrcode
      }}</span>
    </div>
  </div>
  <!-- </div> -->
</template>

<script>
import TicketSessions from "./TicketSessions.vue";

export default {
  props: {
    billet: {
      type: Object,
    },
  },
  components: { TicketSessions }
};
</script>